import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const SearchConsoleSource = {
  fetchStatus: function() {
    return axios.get(`${API_BASE}/search_console/status`)
      .then(resp => resp.data)
  },
  searchAnalyticsQuery: function() {
    return axios.get(`${API_BASE}/search_console/search_analytics_query`, { catchErrors: false })
      .then(resp => resp.data)
  },
  searchAnalyticsQueryLegacy: function() {
    return axios.get(`${API_BASE}/search_console/search_analytics_query_legacy`, { catchErrors: false })
      .then(resp => resp.data)
  },
  listSites: function() {
    return axios.get(`${API_BASE}/search_console/list_sites_legacy`, { catchErrors: false })
      .then(resp => resp.data)
  }
}

export default SearchConsoleSource



// WEBPACK FOOTER //
// ./app/sources/SearchConsoleSource.js